const firebaseConfig = {
    apiKey: "AIzaSyDN7IkPxhvpeIJ61sY4vYx-FnR7v1VYxc8",
    authDomain: "red-onion-web.firebaseapp.com",
    databaseURL: "https://red-onion-web.firebaseio.com",
    projectId: "red-onion-web",
    storageBucket: "red-onion-web.appspot.com",
    messagingSenderId: "719777149765",
    appId: "1:719777149765:web:f16f62b1652512e109442c"
  };

  export default firebaseConfig;